import { updateFontSize } from './utils/update-font-size'
import { addDeviceClasses } from './utils/add-device-classes'

let defaultFontSize = 16
let smallScreenHeightFontSize = 16
let maxFontSize = 24

updateFontSize(defaultFontSize, smallScreenHeightFontSize, maxFontSize)
addDeviceClasses()


$(window).on('resize', function (){
  updateFontSize(defaultFontSize, smallScreenHeightFontSize, maxFontSize)
})
